"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurfaceType = exports.IdType = void 0;
let SurfaceType = exports.SurfaceType = /*#__PURE__*/function (SurfaceType) {
  SurfaceType["Sheet"] = "sheet";
  SurfaceType["Document"] = "document";
  return SurfaceType;
}({});
let IdType = exports.IdType = /*#__PURE__*/function (IdType) {
  IdType["SheetId"] = "sheetId";
  IdType["DocumentId"] = "documentId";
  IdType["LineageUrn"] = "lineageUrn";
  return IdType;
}({});
//# sourceMappingURL=PlacementActivityType.js.map